import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
    CompanyAccess,
    CompanyGroupAccess,
    SaveCompanyGroupUserAccessRequest,
    SaveCompanyUserAccessRequest,
    TenantAccessSummary
} from './tenant-access.model';

@Injectable({ providedIn: 'root' })
export class TenantAccessService {
    private readonly apiUrl = `${environment.restApiUrl}tenant-access`;

    constructor(private http: HttpClient) {}

    getCurrentAccess() {
        return this.http.get<TenantAccessSummary>(`${this.apiUrl}/me`);
    }

    getCustomerAccess(customerId: number) {
        return this.http.get<TenantAccessSummary>(`${this.apiUrl}/customers/${customerId}`);
    }

    getCompanyUsers(companyId: number) {
        return this.http.get<CompanyAccess[]>(`${this.apiUrl}/companies/${companyId}/users`);
    }

    saveCompanyUser(companyId: number, request: SaveCompanyUserAccessRequest) {
        return this.http.post<CompanyAccess>(`${this.apiUrl}/companies/${companyId}/users`, request);
    }

    deactivateCompanyUser(companyId: number, customerId: number, updatedBy?: number) {
        const suffix = updatedBy ? `?updatedBy=${updatedBy}` : '';
        return this.http.delete<CompanyAccess>(`${this.apiUrl}/companies/${companyId}/users/${customerId}${suffix}`);
    }

    getCompanyGroupUsers(companyGroupId: number) {
        return this.http.get<CompanyGroupAccess[]>(`${this.apiUrl}/company-groups/${companyGroupId}/users`);
    }

    saveCompanyGroupUser(companyGroupId: number, request: SaveCompanyGroupUserAccessRequest) {
        return this.http.post<CompanyGroupAccess>(`${this.apiUrl}/company-groups/${companyGroupId}/users`, request);
    }

    deactivateCompanyGroupUser(companyGroupId: number, customerId: number, updatedBy?: number) {
        const suffix = updatedBy ? `?updatedBy=${updatedBy}` : '';
        return this.http.delete<CompanyGroupAccess>(`${this.apiUrl}/company-groups/${companyGroupId}/users/${customerId}${suffix}`);
    }
}
